// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0067b1","secondaryColor":"#e21836","accentColor":"#82b1ff","errorColor":"#ff5252","infoColor":"#2196f3","successColor":"#4caf50","warningColor":"#fb8c00"};